<template>
    <div class="popup-search-results">
        <i class="icon-close"></i>
        <ul>
            <li v-for="item in items">
                <p class="title" v-html="item.title"></p>
                <p v-html="item.search_api_excerpt ? item.search_api_excerpt : item.introduction"></p>
                <p><a :href="urlToPage(item)" :target="getTargetLink(item)" class="link">Voir plus</a></p>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        mounted() {
            this.$eventBus.$on('fillSearchResults', (data) => {
                this.items = data;
                $('.popup-search-results').slideDown(300);
            });

            $('header-right .icon-close').click(function(){
                $('.popup-search-results').slideUp(300);
                $('.block-search').removeClass('active');
                $('body').removeClass('noscroll');
            })
        },
        data() {
            return {
                items: []
            }
        },
        methods: {
            urlToPage(item) {
                if(item.search_api_datasource === 'entity:media') {
                    return item.url_pdf;
                } else {
                    return item.url;
                }
            },
            getTargetLink(item) {
                if(item.search_api_datasource === 'entity:media') {
                    return "_blank";
                } else {
                    return "_self";
                }
            }
        }
    }
</script>
